import JSConfetti from 'js-confetti';

export const jsConfetti = new JSConfetti();
